import { getStore, setStore } from '@/config/mUtils'
import 'whatwg-fetch'

var tokenExpired = false

export default async (url = '', data = {}, type = 'GET', method = 'fetch') => {
	type = type.toUpperCase();
	let userInfo = getStore('userInfo');
	let token = ""
	if (userInfo) {
		token = userInfo.token
	}
	let token_validate = data.token_validate == false ? data.token_validate : true
	if (token_validate && (!token || tokenExpired)) {
		window.location.href = '/login'
		return
	}

	if (type == 'GET') {
		data.t = new Date().getTime()
		let dataStr = ''; //数据拼接字符串
		Object.keys(data).forEach(key => {
			dataStr += key + '=' + data[key] + '&';
		})

		if (dataStr !== '') {
			dataStr = dataStr.substr(0, dataStr.lastIndexOf('&'));
			url = url + '?' + dataStr;
		}
	}

	let requestConfig = {
		method: type,
		headers: {
			'Accept': 'application/json',
			'Content-Type': 'application/json',
			'Token': token,
		},
		mode: "cors"
	}

	if (type == 'POST' || type == 'PUT') {
		Object.defineProperty(requestConfig, 'body', {
			value: JSON.stringify(data)
		})
	}

	try {
		let response = await fetch(url, requestConfig);
		let responseJson = await response.json();

		if (responseJson.code == -3) {
			if (responseJson.data.auth_codes) {
				userInfo.auth_codes = responseJson.data.auth_codes
				userInfo.is_super_admin = responseJson.data.is_super_admin
				setStore('userInfo', userInfo)
				window.location.reload()
			} else if (responseJson.data.token) {
				userInfo.token = responseJson.data.token
				setStore('userInfo', userInfo)

				requestConfig.headers.Token = responseJson.data.token
				response = await fetch(url, requestConfig);
				responseJson = await response.json();
				return responseJson
			} else {
				tokenExpired = true
				setStore('userInfo', '');
				window.location.href = '/login'
			}
			return
		}

		if (responseJson.code == -1 || responseJson.code == -2) {
			tokenExpired = true
			setStore('userInfo', '');
			window.location.href = '/login'
			return
		}

		if (responseJson.code == -4) {
			alert(responseJson.message)
			tokenExpired = true
			setStore('userInfo', '');
			window.location.href = '/login'
			return
		}

		if (responseJson.code && responseJson.code != 0) {
			alert(responseJson.message)
		}

		if (responseJson.status == -1 || responseJson.error_code == -1) {
			const msg = responseJson.msg || responseJson.error_msg
			alert(msg)
		}

		return responseJson
	} catch (error) {
		throw new Error(error)
	}
}